import { render, staticRenderFns } from "./latestNotification.vue?vue&type=template&id=1558c734"
import script from "./latestNotification.vue?vue&type=script&lang=js"
export * from "./latestNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1558c734')) {
      api.createRecord('1558c734', component.options)
    } else {
      api.reload('1558c734', component.options)
    }
    module.hot.accept("./latestNotification.vue?vue&type=template&id=1558c734", function () {
      api.rerender('1558c734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/widgets/latestNotification.vue"
export default component.exports